module.exports = require("./bo-CN");